// Counting plays (and drags into songs, from the DAW plugin) from the browser: each rhythm once a
// day per browser (the server counts each listener once a day too), sent without holding up
// playback.
import { isRef } from "./refs";

const today = () => Math.floor(Date.now() / 864e5);
const sent = {};
function counted(key) {
  if (sent[key]?.day === today()) return sent[key];
  try { const saved = JSON.parse(window.localStorage.getItem(key) || "null"); sent[key] = saved?.day === today() ? { day: saved.day, refs: new Set(saved.refs) } : null; } catch { sent[key] = null; }
  return sent[key] ||= { day: today(), refs: new Set() };
}
function record(refs, kind) {
  if (typeof window === "undefined") return;
  const key = kind === "use" ? "truechops.uses" : "truechops.plays", marks = counted(key);
  for (const ref of [].concat(refs || []).filter(isRef)) {
    if (marks.refs.has(ref)) continue;
    marks.refs.add(ref);
    fetch(`/api/social/stats/${kind}`, { method: "POST", keepalive: true, credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ ref }) }).catch(() => {});
  }
  try { window.localStorage.setItem(key, JSON.stringify({ day: marks.day, refs: [...marks.refs].slice(-500) })); } catch { /* Private mode: counted for this visit only. */ }
}
export const recordPlay = (refs) => record(refs, "play");
export const recordUse = (refs) => record(refs, "use");
